"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvoiceNumberValid = exports.isMaxLengthOfInvoiceNumberRespected = exports.isMinLengthOfInvoiceNumberRespected = void 0;
const common_1 = require("../common");
const input_validator_1 = require("./input.validator");
const validationConsts_1 = require("./validationConsts");
const isMinLengthOfInvoiceNumberRespected = (val) => (0, common_1.isAtLeastNChar)(val, validationConsts_1.MIN_INVOICE_NUMBER_LENGTH);
exports.isMinLengthOfInvoiceNumberRespected = isMinLengthOfInvoiceNumberRespected;
const isMaxLengthOfInvoiceNumberRespected = (val) => (0, common_1.isAtMostNChar)(val, validationConsts_1.MAX_INVOICE_NUMBER_LENGTH);
exports.isMaxLengthOfInvoiceNumberRespected = isMaxLengthOfInvoiceNumberRespected;
const isInvoiceNumberValid = (val, config) => {
    if ((0, common_1.isEmptyStringOrNullish)(val)) {
        return !!(config === null || config === void 0 ? void 0 : config.allowEmpty);
    }
    return [input_validator_1.isAllowedSingleLineCharsOnly, exports.isMinLengthOfInvoiceNumberRespected, exports.isMaxLengthOfInvoiceNumberRespected, input_validator_1.isNoWhitespace].every((validate) => validate(val));
};
exports.isInvoiceNumberValid = isInvoiceNumberValid;
